// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Ingred_wrapper__jlFA3"};